/* ReHair award redesign, 2026-10-23: scroll reveals for the homepage and the hair patch guide, plus the guide's
   chapter rail and area map. Only elements that start below the fold are hidden, so nothing visible flashes. */
(function () {
  window.__rhAward = true;
  var root = document.documentElement;
  var motion = root.classList.contains('rh-motion') && 'IntersectionObserver' in window;

  var GROUPS = [
    ['.rehair-home-intro h2, .rehair-home-intro__text', ''],
    ['#MainContent .m-section__header', ''],
    ['.m-product-tabs .m-tab-content.active .m-product-card, .m-product-tabs .m-tab-content:first-child .m-product-card', ''],
    ['.m-lookbook .m-stl-card', ''],
    ['.rehair-home-custom__media, .rehair-antimicrobial-home__media', 'media'],
    ['.rehair-home-custom__content > *, .rehair-home-custom__process li, .rehair-antimicrobial-home__copy > *', ''],
    ['.m-testimonials__inner', ''],
    ['.rehair-journey-list > li', ''],
    ['.rh-guide__media, .rh-chapter > h2, .rh-chapter .rh-cards > li, .rh-chapter .rh-area-table tbody tr, .rh-faq__item, .rh-guide__map', '']
  ];

  function reveal() {
    if (!motion) return;
    var fold = window.innerHeight * 0.92;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    GROUPS.forEach(function (g) {
      var seen = new Map();
      document.querySelectorAll(g[0]).forEach(function (el) {
        if (el.hasAttribute('data-rh-reveal')) return;
        var r = el.getBoundingClientRect();
        if (!r.height || r.top < fold) return;
        // stagger siblings that share a row
        var key = el.parentElement, n = seen.get(key) || 0;
        seen.set(key, n + 1);
        el.style.setProperty('--rh-i', String(n % 4));
        el.setAttribute('data-rh-reveal', g[1]);
        io.observe(el);
      });
    });
  }

  // Guide: highlight the chapter in view in the rail.
  function rail() {
    var links = document.querySelectorAll('.rh-rail a[href^="#"]');
    if (!links.length || !('IntersectionObserver' in window)) return;
    var byId = {};
    links.forEach(function (a) { byId[a.getAttribute('href').slice(1)] = a; });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        links.forEach(function (a) { a.classList.remove('is-active'); a.removeAttribute('aria-current'); });
        var a = byId[e.target.id];
        if (a) { a.classList.add('is-active'); a.setAttribute('aria-current', 'true'); }
      });
    }, { rootMargin: '-35% 0px -60% 0px' });
    Object.keys(byId).forEach(function (id) { var s = document.getElementById(id); if (s) io.observe(s); });
  }

  // Guide: area map zones <-> legend <-> table rows.
  function areaMap() {
    var map = document.querySelector('.rh-guide__map');
    if (!map) return;
    var rows = document.querySelectorAll('.rh-area-table tbody tr');
    function set(zone, on) {
      map.querySelectorAll('[data-zone="' + zone + '"]').forEach(function (el) { el.classList.toggle('is-on', on); });
    }
    map.querySelectorAll('.rh-map__legend button').forEach(function (b) {
      var zone = b.getAttribute('data-zone');
      b.addEventListener('mouseenter', function () { set(zone, true); });
      b.addEventListener('mouseleave', function () { set(zone, false); });
      b.addEventListener('focus', function () { set(zone, true); });
      b.addEventListener('blur', function () { set(zone, false); });
      b.addEventListener('click', function () {
        var idx = (b.getAttribute('data-rows') || '').split(',').map(Number);
        var first = rows[idx[0]];
        rows.forEach(function (r) { r.classList.remove('is-picked'); });
        idx.forEach(function (i) { if (rows[i]) rows[i].classList.add('is-picked'); });
        if (first) {
          first.scrollIntoView({ behavior: motion ? 'smooth' : 'auto', block: 'center' });
          var link = first.querySelector('a');
          if (link) setTimeout(function () { link.focus({ preventScroll: true }); }, motion ? 600 : 0);
        }
      });
    });
  }

  function init() { reveal(); rail(); areaMap(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
